import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-collaborationlist',
    templateUrl: './collaborationlist.component.html',
    styleUrls: ['./collaborationlist.component.scss'],
    standalone: false,
})
export class CollaborationlistDialog implements OnInit {
    collaborationAddList: boolean;
    collaborationPartnerList: boolean;
    addCollaboratorsForm = true;
    showListOfCollaborators = false;

    constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}

    showCollaborationShare = () => {
        this.collaborationAddList = true;
        this.collaborationPartnerList = false;
        this.addCollaboratorsForm = false;
        this.showListOfCollaborators = true;
    };

    collaboratorsParnersList = () => {
        this.collaborationAddList = false;
        this.collaborationPartnerList = true;
        this.showListOfCollaborators = false;
        this.addCollaboratorsForm = true;
    };

    ngOnInit(): void {}
}
